import {mapPathnameToOfferType} from "../../../../common/app/routing/offer_type";
import {IActionContext} from "../create_path_to_action";
import {setAuthAndUser} from "./set_auth_and_user";
import {setLatestEntryAction} from "./set_latest_entry";

export const cityAction = async (ctx: IActionContext<Record<string, never>>) => {
    await setAuthAndUser(ctx.store);
    await setLatestEntryAction(ctx.store);

    mapPathnameToOfferType(ctx.route.pathname);
};
